// extracted by mini-css-extract-plugin
export default {"textareaCount":"TextAreaCount_textareaCount__ic-GV","label":"TextAreaCount_label__-AbpU"};